import { SVG, IconProps } from "../SVG";
import React from "react";

export const FunctionalFinancialAid = (props: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 146 129" {...props}>
        <mask
            id="spot-illustration-financial-aid_svg__a"
            width={146}
            height={129}
            x={0}
            y={0}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: "alpha",
            }}
        >
            <path fill="#D9D9D9" d="M0 0h146v129H0z" />
        </mask>
        <g mask="url(#spot-illustration-financial-aid_svg__a)">
            <path
                fill="#C9DBFE"
                d="M72.5 75C93.21 75 110 58.21 110 37.5S93.21 0 72.5 0 35 16.79 35 37.5 51.79 75 72.5 75Z"
            />
            <path
                fill="#13126C"
                d="m90.63 40.359-1.91 1.91-16.602 16.603L53.62 40.374c-4.57-4.57-4.57-12 0-16.602a11.738 11.738 0 0 1 8.301-3.424c3.012 0 6.008 1.146 8.301 3.424l1.911 1.91 1.911-1.91c4.571-4.571 12-4.571 16.587 0 4.586 4.586 4.586 12.016 0 16.602v-.015Z"
            />
            <path
                fill="#fff"
                d="M87.641 27.53H86.18v-1.462c0-.98-.789-1.769-1.769-1.769-.98 0-1.769.789-1.769 1.77v1.46H81.18c-.98 0-1.769.79-1.769 1.77s.79 1.77 1.77 1.77h1.461v1.46c0 .98.79 1.77 1.77 1.77s1.768-.79 1.768-1.77v-1.46h1.462c.98 0 1.77-.79 1.77-1.77s-.79-1.77-1.77-1.77Z"
            />
            <path
                fill="#DB8E7D"
                fillRule="evenodd"
                d="M36.672 85.668c-.93.193-1.729-.777-2.21-1.214-9.739-8.807-7.53-14.537-7.336-17.631.33-5.215.395-5.41.47-6.343.68-8.425-4.21-9.575-5.851-5.156a33.579 33.579 0 0 0-1.289 5.289l-.067.394c-.269-3.023-.446-7.057-1.152-9.705a2.889 2.889 0 0 0-3.366-2.366c-1.617.322-2.57 3.067-2.941 4.472a40.114 40.114 0 0 0-.996 4.867c-2.31-4.02-4.836-7.566-6.542-7.097-3.484.93-1.44 9.394 2.376 19.66 2.139 5.802 3.686 12.457 5.39 14.078 5.1 4.8 7.508 7.694 13.387 12.82 3.519 3.101 6.279 5.732 7.024 10.347.19 1.221.425 6.945.48 6.928-.108-.482 20.794-.019 20.706-.509-.913-5.71.94-13.167-2.256-18.314a131.436 131.436 0 0 0-7.573-14.443 47.942 47.942 0 0 1-2.406-5.105c-2.714-6.39-3.65-7.868-4.585-8.198-1.826-.636-5.36 3.541-3.768 8.542 1.026 3.237 2.158 5.446 2.735 6.955.264.698.51 1.462-.215 1.756"
                clipRule="evenodd"
            />
            <path
                fill="#79CCAC"
                d="M27.317 115.148c3.105-1.981 26.925-2.999 32.574.498.548.342 4.489 8.371.58 9.783-3.91 1.411-33.397.087-35.363-1.645-1.966-1.732 1.635-8.267 2.209-8.636Z"
            />
            <path
                fill="#65657B"
                fillRule="evenodd"
                d="M19.093 66.578a.75.75 0 0 1 .651.837c-.5 3.995-.73 6.836.462 10.153.86 2.395 2.02 4.019 3.033 5.121.507.553.982.98 1.373 1.311.13.11.245.206.353.295l.172.143c.144.12.294.248.407.368a.75.75 0 1 1-1.088 1.032 3.816 3.816 0 0 0-.281-.25l-.155-.127a40.714 40.714 0 0 1-.379-.317c-.419-.356-.943-.826-1.507-1.44-1.13-1.23-2.404-3.023-3.34-5.629-1.323-3.683-1.039-6.841-.538-10.846a.75.75 0 0 1 .837-.651Z"
                clipRule="evenodd"
            />
            <circle cx={54} cy={120} r={3} fill="#5C9A82" />
            <path
                fill="#DB8E7D"
                fillRule="evenodd"
                d="M108.816 85.668c.93.193 1.728-.777 2.209-1.214 9.739-8.807 7.53-14.537 7.336-17.631-.329-5.215-.395-5.41-.471-6.343-.678-8.425 4.212-9.575 5.853-5.156a33.611 33.611 0 0 1 1.288 5.289l.067.394c.269-3.023.446-7.057 1.152-9.705a2.886 2.886 0 0 1 2.23-2.345 2.89 2.89 0 0 1 1.137-.021c1.616.322 2.569 3.067 2.941 4.472.432 1.6.764 3.226.995 4.867 2.309-4.02 4.836-7.566 6.543-7.097 3.483.93 1.439 9.394-2.377 19.66-2.138 5.802-3.686 12.457-5.39 14.078-5.1 4.8-7.508 7.694-13.387 12.82-3.519 3.101-6.278 5.732-7.024 10.347-.19 1.221-.425 6.945-.48 6.928.108-.482-20.794-.019-20.706-.509.913-5.71-.939-13.167 2.256-18.314a131.502 131.502 0 0 1 7.573-14.443 47.844 47.844 0 0 0 2.406-5.105c2.714-6.39 3.651-7.868 4.586-8.198 1.825-.636 5.359 3.541 3.767 8.542-1.026 3.237-2.158 5.446-2.735 6.955-.264.698-.51 1.462.215 1.756"
                clipRule="evenodd"
            />
            <path
                fill="#79CCAC"
                d="M118.171 115.148c-3.106-1.981-26.926-2.999-32.574.498-.55.342-4.49 8.371-.58 9.783 3.909 1.411 33.396.087 35.362-1.645 1.966-1.732-1.635-8.267-2.208-8.636Z"
            />
            <path
                fill="#65657B"
                fillRule="evenodd"
                d="M126.394 66.578a.75.75 0 0 0-.651.837c.499 3.995.73 6.836-.462 10.153-.86 2.395-2.02 4.019-3.032 5.121-.508.553-.983.98-1.373 1.311-.13.11-.246.206-.354.295l-.171.143a4.88 4.88 0 0 0-.408.368.75.75 0 0 0 1.088 1.032c.045-.047.13-.122.281-.25l.155-.127.379-.317c.419-.356.944-.826 1.507-1.44 1.131-1.23 2.404-3.023 3.34-5.629 1.323-3.683 1.039-6.841.538-10.846a.75.75 0 0 0-.837-.651Z"
                clipRule="evenodd"
            />
            <circle cx={3} cy={3} r={3} fill="#5C9A82" transform="matrix(-1 0 0 1 94.487 117)" />
        </g>
    </SVG>
);
FunctionalFinancialAid.displayName = "FunctionalFinancialAid";
